import Image from "next/image";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { Theme } from "@mui/system";
import { BrandName, HeadingLevel } from "@/core/types/types";
import { Box, Typography } from "@mui/material";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { getLegalAreaConfig } from "@/core/utils/getBrandConfiguration";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import { useContext } from "react";

const styles = (theme: Theme) => ({
  root: {
    display: "flex",
    marginBottom: theme.spacing(2),
    alignItems: "center",
    "& img": {
      margin: theme.spacing(1, 1.75, 1, 0),
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
});

export default function Advantages({ brandName }: BrandName) {
  const classes: any = useCustomStyles(styles);
  const initializationConfig = useContext(ConfigContext);
  const icons: string[] = getLegalAreaConfig(
    brandName,
    initializationConfig?.legalArea
  ).advantageIcons!;

  return (
    <>
      {icons?.map((icon, index) => {
        return (
          <Box key={index} sx={classes?.root}>
            <Image
              src={`images/icons/sidebar/${icon}.svg`}
              alt={icon}
              width="40"
              height="40"
            />
            <Typography variant={HeadingLevel.Body2}>
              {t(`common.sidebar.advantages.article.${index}`)}
            </Typography>
          </Box>
        );
      })}
    </>
  );
}
